import { LogLevel } from "@azure/msal-browser";

let redirectUri;
if (window.location.origin === "https://inalabgroup.com") {
  redirectUri = "https://inalabgroup.com";
} else if (window.location.origin === "https://www.inalabgroup.com") {
  redirectUri = "https://www.inalabgroup.com";
} else {
  // fallback for local dev or other environments
  redirectUri = window.location.origin;
}

export const msalConfig = {
  auth: {
    clientId: "24f1ba53-0827-4dfb-9093-6025a5d6beee",
    authority: "https://login.microsoftonline.com/484c50a2-a304-4372-bd7d-d4bc8e0f1924",
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error: console.error(message); break;
          case LogLevel.Info: console.info(message); break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message); break;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};